export interface SerializedSaveOutcome<T> {
  result: T;
  updatedAt?: string | null;
}

function newest(a: string | null | undefined, b: string | null | undefined): string | undefined {
  if (!a) return b ?? undefined;
  if (!b) return a;
  const left = Date.parse(a);
  const right = Date.parse(b);
  if (Number.isNaN(left)) return b;
  if (Number.isNaN(right)) return a;
  return right > left ? b : a;
}

export function createSaveSerializer() {
  let tail: Promise<unknown> = Promise.resolve();
  let latestSavedAt: string | undefined;

  return {
    run<T>(
      loadedUpdatedAt: string | null | undefined,
      task: (expectedUpdatedAt: string | undefined) => Promise<SerializedSaveOutcome<T>>,
    ): Promise<T> {
      const next = tail.then(async () => {
        const expected = newest(loadedUpdatedAt, latestSavedAt);
        const outcome = await task(expected);
        latestSavedAt = newest(latestSavedAt, outcome.updatedAt);
        return outcome.result;
      });
      tail = next.catch(() => undefined);
      return next;
    },
    reset(): void {
      latestSavedAt = undefined;
    },
  };
}
